import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Inventory_ds_get_location_by_locationId_detailedService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { locationId: number }): 
  Promise<{ result: { Id?: number, ChildFootprint?: number, ChildStackHeight?: number, EligibleForAllocation?: boolean, Height?: number, IsLoose?: boolean, Length?: number, MixingRuleId?: number, Name?: string, SkipValidationRules?: boolean, StatusId?: number, TypeId?: number, VolumeCapacity?: number, WarehouseId?: number, WeightCapacity?: number, Width?: number, Status?: { Name?: string }, Warehouse?: { Id?: number, Name?: string }, Type?: { Name?: string }, WeightUom?: { Id?: number, Name?: string }, VolumeUom?: { Id?: number, Name?: string }, DimensionsUom?: { Id?: number, Name?: string }, StorageCategory?: { Id?: number, LookupCode?: string } } }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.locationId)) {
      missingRequiredInParams.push('\'locationId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      locationId: number    }) {
        if(isNil(inParams.locationId)) {
          return true; 
        }
      return false;
    }
}
